// Mock implementation of react-native-inappbrowser-reborn for web
// This module is not used on web (browser navigation is used directly instead)
// but we need to provide a mock to prevent build errors (its index.js ships
// TypeScript syntax that the web build's babel pipeline does not transpile)

const InAppBrowser = {
  isAvailable: () => Promise.resolve(false),
  open: () => {
    console.warn("react-native-inappbrowser-reborn is not supported on web")
    return Promise.reject(new Error("react-native-inappbrowser-reborn is not supported on web"))
  },
  close: () => {},
  openAuth: () => {
    console.warn("react-native-inappbrowser-reborn is not supported on web")
    return Promise.reject(new Error("react-native-inappbrowser-reborn is not supported on web"))
  },
  closeAuth: () => {},
}

export default InAppBrowser
